var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var symboll = window.shop_symbol;
if (document.querySelector('[name="country_code"]') != null) {
  symboll = document
    .querySelector('[name="country_code"]')
    .getAttribute("symbol");
}
Shopify.money_format = symboll + "{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
const cartItem = `<div data-product="%VARIANT_ID%" data-gift-product="%giftProduct%" class="columns is-multiline is-mobile is-marginless cart-drawer__products item-%PRODUCT_ID% shopItem">
      <div class="column is-4-desktop is-4-tablet is-3-mobile productImage">
          <a href="/products/%HANDLE%" aria-label="Product link">%PRODUCT_IMAGE%</a>
      </div>
      <div class="column is-8-desktop is-8-tablet is-8-mobile">
        <div class="cart__drawer--title">
          <a href="/products/%HANDLE%" aria-label="Product Title" tabindex="0"
          class="margin-b-10 margin-b-10 product-title" tabindex="0">%PRODUCT_TITLE%</a>
		<p class="select__variant">%SELECTED_VARIANT%</p>
	%PROPERTIES%
	<p class="selling-plan"></p>
          <p class="product-price %PRODUCT_STATE%">
          <span class="price-item price-item--sale ">%FINAL_PRICE%</span> 
          <span class="price-item price-item--regular money" style="display:none">%COMPARE_PRICE%</span>
          </p>
          <div class="unit_price" unit_price>%UNIT_PRICE%</div>
        </div>
          <div class="form-field form-options js-required">

          <div class="product-form__input product-form__quantity">
           <div class="quantity__main">
    <button class="quantity_button quantity__decrease">
      <span>-</span>
    </button>
    <div class="quantity_button quantity_num">
      <input id="quantity" name="quantity" type="number" min="1" value="%ITEM-QUANTITY%" variant_id="%PRODUCT_ID%">
    </div>
    <button class="quantity_button quantity__increase">
      <span>+</span>
    </button>
  </div>
          </div>
          </div>
          <a href="javascript:void(0)" onClick="removeItem(%VARIANT_ID%);" class="is-marginless removeItem">${window.cartItems.remove}</a>
      </div>
  </div>`;
var isOpen = false;

var addedSuggested = 0;
var timer;

$("body").delegate(
  ".add-to-cart-btn , .product-form__submit",
  "click",
  function (e) {
    if (window.settings.cartType === "cart-drawer") {
      e.preventDefault();
      var product_id = $(this).attr("product_id");
      var metaf = $(this).attr("metaf");
      var $form = $(this).parents("form");
      var trgt = {
        id: $form.find('[name="id"]').val(),
        quantity: $form.find('[name="quantity"]').val() || 1,
      };
      // Collect Globo / custom option properties from form hidden inputs
      var _props = {};
      $form.find('[name^="properties["]').each(function () {
        var match = $(this).attr("name").match(/properties\[(.+)\]/);
        if (match) {
          var val = $(this).val();
          if (val !== "" && val !== null) {
            _props[match[1]] = val;
          }
        }
      });
      if (Object.keys(_props).length > 0) {
        trgt.properties = _props;
      }
      var data = {
        items: [],
      };
      data["items"].push(trgt);
      // Add gift wrapping to cart;
      if (
        $(this).closest(".product__detail") &&
        $(this).closest(".product__detail").find(".product__wrapping")
      ) {
        var gift_wrapping_container = $(this)
          .closest(".product__detail")
          .find(".product__wrapping");
        if (
          gift_wrapping_container
            .find("input#add_gift_wrapping")
            .prop("checked")
        ) {
          var gift_wrapping_id = gift_wrapping_container.attr("data-gift-id");
          var message = gift_wrapping_container.find("textarea").val();
          var product = $(this).parents("form").find('[name="id"]').val();
          var gift = {
            id: gift_wrapping_id,
            quantity: $(this).parents("form").find('[name="quantity"]').val(),
            properties: {
              _gift_wrapping_message: message,
              _gift_wrapping_product: product,
            },
          };
          data["items"].push(gift);
        }
      }
      addProductToCart(product_id, metaf, product_id, data);
      $("#quick-view .quick-view_grid").remove();
      $("#quick-view").hide();
    }
  }
);

$(document).on(
  "click",
  ".cart-drawer .quantity__decrease, .cart-drawer .quantity__increase",
  function (event) {
    event.preventDefault();
    var _this = $(this);
    var curnt_vlu = $(this)
      .parents(".quantity__main")
      .find('[name="quantity"]')
      .val();
    if ($(this).hasClass("quantity__increase")) {
      curnt_vlu = parseFloat(curnt_vlu) + 1;
    } else if ($(this).hasClass("quantity__decrease")) {
      if (curnt_vlu > 0) {
        curnt_vlu = parseFloat(curnt_vlu) - 1;
      }
    }
    setTimeout(function () {
      testQty(
        _this
          .parents(".quantity__main")
          .find('[name="quantity"]')
          .attr("variant_id"),
        curnt_vlu
      );
    }, 50);
  }
);
$(document).on("change", '.cart-drawer [name="quantity"]', function (event) {
  event.preventDefault();
  var curnt_vlu = $(this)
    .parents(".quantity__main")
    .find('[name="quantity"]')
    .val();
  var _this = $(this);
  setTimeout(function () {
    testQty(
      _this
        .parents(".quantity__main")
        .find('[name="quantity"]')
        .attr("variant_id"),
      curnt_vlu
    );
  }, 50);
});
function addProductToCart(formID, metafields, productID, target) {
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  $.ajax({
    type: "POST",
    url: window.routes.cart_add_url + ".js",
    dataType: "json",
    data: target,
    success: addToCartOk,
    error: function (xhr, textStatus, error) {
      var data_rrot = JSON.parse(xhr.responseText);
      console.log(xhr.responseText);
      alert(data_rrot.description);
    },
  });
  if (metafields != "") {
    window.localStorage.setItem("metafields-" + productID, metafields);
  }
  return false;
}

function testQty(itemID, value) {
  if (value != "Dummy") {
    changeItem(itemID, value);
  }
}

function fetchCart() {
  $.ajax({
    type: "GET",
    url: window.routes.cart_url + ".js",
    dataType: "json",
    success: function (cart) {
      onCartUpdate(cart);
      renderCart(cart);
    },
  });
}

function changeItem(line, quantity, callback) {
  if (isNotLoading()) {
    startLoading();
  }
  // Check if this product has gift wrapping
  if ($(`.cart [data-gift-product="${line}"]`).length !== 0) {
    var new_id = $(`.cart [data-gift-product="${line}"]`).attr("data-product");
    var data =
      "updates[" +
      line +
      "]=" +
      quantity +
      "&updates[" +
      new_id +
      "]=" +
      quantity;
  } else {
    var data = "updates[" + line + "]=" + quantity;
  }

  $.ajax({
    type: "POST",
    url: window.routes.cart_update_url + ".js",
    data: data,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
      }
      if ($("body").hasClass("template--cart")) {
        $(".products-cart").each(function () {
          var _ths_itm = $(this);
          var elemt_rmv = 0;
          var element_id = $(this).attr("data-id-cart");
          cart.items.forEach(function (elenmt, indx) {
            if (elenmt.id == element_id) elemt_rmv = 1;
          });
          if (elemt_rmv == 0) {
            _ths_itm.remove();
          }
        });
        cart.items.forEach(function (itm, indx) {
          $('[data-id-cart="' + itm.id + '"]')
            .find(".product-price-cart .price-cart")
            .text(Shopify.formatMoney(itm.final_price));
          var cross_new = parseFloat(itm.price) * parseFloat(itm.quantity);
          $('[data-id-cart="' + itm.id + '"]')
            .find(".product-line-price del.cart-item__old-price")
            .text(Shopify.formatMoney(cross_new));
          $('[data-id-cart="' + itm.id + '"]')
            .find(".product-line-price span")
            .text(Shopify.formatMoney(itm.final_line_price));
          $('[data-id-cart="' + itm.id + '"]')
            .find('[name="quantity"]')
            .val(itm.quantity);
          $('[data-id-cart="' + itm.id + '"]')
            .find('[name="quantity"]')
            .attr("value", itm.quantity);
        });
        $("p.totals__subtotal-value").text(
          Shopify.formatMoney(cart.total_price) + " " + Shopify.currency.active
        );
      }
      if (cart.item_count < 1) {
        $(".cart-page").html(
          '<div class="cart__warnings"> <h2 class="cart__empty-text">Your cart is empty</h2> <a href="' +
            window.routes.collection_url +
            '" class="link button button--primary"> Continue shopping </a> </div>'
        );
      }
    },
    error: function (xhr, textStatus, error) {
      console.log(xhr.responseText);
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
    },
  });
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}

function removeItem(itemID) {
  changeItem(itemID, 0);
  $("item-" + itemID).remove();
}

function onCartUpdate(cart) {
  // Do nothing, logic handled before render
}

function addToCartOk(product) {
  if (isNotLoading()) {
    startLoading();
  }
  if (!isCartOpen()) {
    openCart();
  }
  // Longer delay gives Globo time to finish its own cart operations
  // (price modifiers, add-on line items) before we fetch the final cart state
  setTimeout(() => fetchCart(), 1200);
  setTimeout(() => fetchCart(), 2500);
}

function addToCartFail() {
  console.log("Error adding to cart: -------------------");
}

function renderCart(cart) {
  const cartItemHolder = $(".cart-drawer__cart");

  if (cart.items.length != 0) {
    $(".cartEmptyHolder").addClass("is-hidden");
    $(".cartItemHolder").removeClass("is-hidden");
  } else {
    $(".cartEmptyHolder").removeClass("is-hidden");
    $(".cartItemHolder").addClass("is-hidden");
  }

  $("#product1Variant").change(function () {
    $("#product1_price").text(product1_price[this.value]);
    $("#product1_compare").text(product1_compare[this.value]);
  });

  var cartCount = $(".site-header-cart--count");

  $(".header-cart-count").text(cart.item_count);

  $(".shopItem").remove();

  var cartTotal = 0;

  $("#product1Form").css("display", "block");
  $("#product2Form").css("display", "block");
  $(".cart-drawer_similar-header").css("display", "block");
  addedSuggested = 0;

  cart.items.forEach(function (item, index) {
    var handle_p = item.url.split("?")[0];
    var compare_price = "";
    $.getJSON(handle_p + ".js", function (prod) {
      var _indx = prod.variants.findIndex(function (x) {
        return x.id == item.id;
      });
      compare_price = prod.variants[_indx].compare_at_price;
      // console.log(prod,compare_price)
      if (compare_price != "" && compare_price != null) {
        var seletr = ".item-" + item.id;
        $(
          seletr +
            " p.product-price.price--on-regular span.price-item.price-item--regular.money"
        ).text(Shopify.formatMoney(compare_price));
        $(
          seletr +
            " p.product-price.price--on-regular span.price-item.price-item--regular.money"
        ).css("display", "inline-block");
      } else {
        var disocunt_price = item.discounted_price;
        var original_price = item.price;
        if (original_price != disocunt_price) {
          compare_price = original_price;
          var seletr1 = ".item-" + item.id;
          $(
            seletr1 +
              " p.product-price.price--on-regular span.price-item.price-item--regular.money"
          ).text(Shopify.formatMoney(compare_price));
          $(
            seletr1 +
              " p.product-price.price--on-regular span.price-item.price-item--regular.money"
          ).css("display", "inline-block");
        }
      }
    });
    // console.log(item,'item',cart,compare_price)
    cartTotal += item.quantity;
    var subtotal = "" + Shopify.formatMoney(cart.items_subtotal_price);
    var original_subtotal = "" + Shopify.formatMoney(cart.original_total_price);
    var discounted_cal =
      parseFloat(cart.original_total_price) -
      parseFloat(cart.items_subtotal_price);
    var discounted_amount = "" + Shopify.formatMoney(discounted_cal);
    var cost = "" + Shopify.formatMoney(item.final_price);
    var cost2 = cost;
    if (item.unit_price != undefined) {
      var unit_price = Shopify.formatMoney(item.unit_price);
      var referal_unit = "";
      if (item.unit_price_measurement.reference_value != 1) {
        referal_unit =
          item.unit_price_measurement.reference_value +
          item.unit_price_measurement.reference_unit;
      } else {
        referal_unit = item.unit_price_measurement.reference_unit;
      }
      var unit_price_referal = unit_price + " / " + referal_unit;
    } else {
      unit_price_referal = "";
    }
    var _imgr = "";
    if (item.image != null) {
      var img_tag_src = item.image
        .replace(".png", "_170x170_crop_center.png")
        .replace(".jpg", "_170x170_crop_center.jpg");
      _imgr = '<img src="' + img_tag_src + '" loading="lazy" alt="product" />';
    } else {
      _imgr =
        '<svg xmlns="http://www.w3.org/2000/svg" class="has-background-light" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>';
    }

    var cartItem2 = replaceAll(cartItem, "%PRODUCT_TITLE%", item.product_title);
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_IMAGE%", _imgr);
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_STATE%", "price--on-regular");
    cartItem2 = replaceAll(cartItem2, "%FINAL_PRICE%", cost2);
    cartItem2 = replaceAll(cartItem2, "%UNIT_PRICE%", unit_price_referal);

    if (compare_price > 0) {
      cartItem2 = replaceAll(
        cartItem2,
        "%COMPARE_PRICE%",
        Shopify.formatMoney(compare_price)
      );
    }
    cartItem2 = replaceAll(cartItem2, "%ITEM-QUANTITY%", item.quantity);

    if (item.variant_options[0] != "Default Title") {
      cartItem2 = replaceAll(
        cartItem2,
        "%SELECTED_VARIANT%",
        item.variant_title
      );
    } else {
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT%", " ");
    }
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_ID%", item.id);
    cartItem2 = replaceAll(cartItem2, "%VARIANT_ID%", item.variant_id);
    cartItem2 = replaceAll(cartItem2, "%HANDLE%", item.handle);
    var propertiesHtml = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function(key) {
        var val = item.properties[key];
        if (key.charAt(0) !== '_' && val !== '' && val !== null) {
          propertiesHtml += '<p class="cart-item__property"><span class="cart-item__property-key">' + key + ':</span> ' + val + '</p>';
        }
      });
    }
    cartItem2 = replaceAll(cartItem2, '%PROPERTIES%', propertiesHtml);
    if (item.properties && item.properties._gift_wrapping_product) {
      cartItem2 = replaceAll(
        cartItem2,
        "%giftProduct%",
        item.properties._gift_wrapping_product
      );
    } else {
      cartItem2 = replaceAll(cartItem2, "%giftProduct%", "");
    }

    cartItemHolder.prepend(cartItem2);
    if (item.selling_plan_allocation == "undefined") {
      $("p.selling-plan").text(item.selling_plan_allocation.selling_plan.name);
    }
    $(".items_subtotal").text(subtotal);
    // $(".cart_subtotal_drawer s").text(original_subtotal);
    var symboll = window.shop_symbol;
    if (document.querySelector('[name="country_code"]') != null) {
      symboll = document
        .querySelector('[name="country_code"]')
        .getAttribute("symbol");
    }
    var vlue_zero = symboll + "0.00";
    // console.log(vlue_zero,'vlue_zero')
    if (discounted_amount != vlue_zero) {
      $(".disocunt_calculate p").text(discounted_amount);
    } else {
      $(".disocunt_calculate p").text(window.cartStrings.discount_policy);
    }
    $(
      "#QTY-" + item.id + " option:nth-child(" + (item.quantity + 1) + ")"
    ).attr("selected", true);
  });
  if (cart.item_count > 1) {
    itemTimer(cart);
  } else if (cart.item_count == 1) {
    itemTimer(cart);
  } else {
    $(".items_subtotal").text("Empty");
    itemTimer(cart);
  }

  if (cartCount.attr("data-header-cart-count") != cartTotal) {
    cartCount.attr("data-header-cart-count", cartTotal);
  }
  stopLoading();
}

function onTidioChatApiReady() {
  setTimeout(() => $("#tidio-chat-iframe").css("z-index", "699"), 500);
}

document.addEventListener("DOMContentLoaded", function () {
  fetchCart();
});

function closeCart() {
  $("html").css("overflow-y", "scroll");
  isOpen = false;
  $(".cart-flyout").addClass("is-closing");
  $(".cart-flyout").removeClass("is-active");
  $(".cart-flyout").hide();
  $(".cartOverlay").css("display", "none");
  setTimeout(() => $(".cart-flyout").removeClass("is-closing"), 750);

  removeTrapFocus(document.getElementById("cart-icon-bubble"));
}

function openCart() {
  $("html").css("overflow-y", "hidden");
  isOpen = true;
  $(".cart-flyout").show();
  $(".cart-flyout").removeClass("is-closing");
  $(".cart-flyout").addClass("is-active");

  let drawerCartElem = document.querySelector(".cart-drawer");

  trapFocus(
    drawerCartElem,
    document.querySelector(".cart-drawer__close > button")
  );

  drawerCartElem.addEventListener("keyup", function (event) {
    if (event.code == "Escape") {
      closeCart();
    }
  });

  setTimeout(() => $(".cartOverlay").css("display", "block"), 50);
}
document
  .getElementById("cart-icon-bubble")
  .addEventListener("click", function (event) {
    if (window.settings.cartType !== "cart-drawer") {
      return;
    }
    event.preventDefault();
    if (!$("body").hasClass("template--cart")) {
      toggleCart();
    }
  });

function toggleCart() {
  event.preventDefault();
  if (isCartOpen()) {
    closeCart();
    return false;
  } else {
    openCart();
    return false;
  }
}

function isCartOpen() {
  return isOpen;
}

function clickOverlay() {
  toggleCart();
}

function addSuggested(formID, metafields, itemID, productID) {
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  if (isNotLoading()) {
    startLoading();
  }
  if (!isCartOpen()) {
    openCart();
  }
  if ($("#" + productID + "Variant").val() != null) {
    itemID = $("#" + productID + "Variant").val();
  }
  $("#" + productID + "Qty").attr("value", $("#" + productID + "Select").val());
  $("#" + productID + "Input").attr("value", itemID);
  addProductToCart(formID, metafields, itemID);
  $("#" + productID + "Form").css("display", "none");
}

function startLoading() {
  $(".cartLoader").removeClass("is-hidden");
}

function stopLoading() {
  $(".cartLoader").addClass("is-hidden");
}

function isNotLoading() {
  return $(".cartLoader").hasClass("is-hidden");
}

function itemTimer(cart) {
  var isSingle = true;
  if (cart.item_count > 1) isSingle = false;
  var second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;
  if (timer || cart.item_count === 0) {
    clearInterval(timer);
  }
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  var countDown = Number(window.localStorage.getItem("timer"));
  if (cart.item_count > 0) {
    timer = setInterval(function () {
      var now = new Date().getTime(),
        distance = countDown - now;
      $(".itemCount").removeClass("is-hidden");
      if (isSingle) {
        $(".itemCount").text(
          ":" +
            " " +
            window.cartItems.cart_count.one.replace(
              "{{ count }}",
              cart.item_count
            )
        );
      } else {
        $(".itemCount").text(
          ":" +
            " " +
            window.cartItems.cart_count.other.replace(
              "{{ count }}",
              cart.item_count
            )
        );
      }
      if (distance > 0) {
      } else {
        if (isSingle) {
          $(".itemCount").text(
            ":" +
              " " +
              window.cartItems.cart_count.one.replace(
                "{{ count }}",
                cart.item_count
              )
          );
        } else {
          $(".itemCount").text(
            ":" +
              " " +
              window.cartItems.cart_count.other.replace(
                "{{ count }}",
                cart.item_count
              )
          );
        }
        // $(".itemCount").text(':' + ' ' + cart.item_count + ` Item${!isSingle ? 's' : ''}`);
      }
    }, 1000);
  } else {
    $(".itemCount").addClass("is-hidden");
  }
}

$(document).ready(function () {
  $('[data_options="color"] input[type="radio"]').change(function () {
    $(this)
      .parents(".product-form__input")
      .find(".form__label span")
      .text($(this).val());
  });

  $(".dropdown_menu .header_link_item").click(function (event) {
    event.preventDefault();
    $(".dropdown_menu .header_link_item")
      .not($(this))
      .parents(".dropdown_menu")
      .removeClass("open");
    $(this).parents(".dropdown_menu").toggleClass("open");
  });

  $(document).mouseup(function (e) {
    var container = $(".dropdown_menu");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".dropdown_menu").removeClass("open");
    }
  });

  var selectors = {
    termsCheckbox: ".cart__terms-checkbox",
    requiresTerms: false,
  };

  if ($(".cart__terms-checkbox").length) {
    selectors.requiresTerms = true;
  }

  if ($("#CartTermsHeaderCart")) {
    $("#CartTermsHeader").change(function () {
      $("#CartTermsHeaderCart").prop("checked", this.checked);
    });
  }

  $(
    ".cart-drawer__proceed-to-checkout,button.cart__checkout-button.button"
  ).click(function (e) {
    if (selectors.requiresTerms) {
      if ($("#CartTermsHeader")[0].checked) {
        // continue to checkout
      } else if (
        $("input#CartTermsHeaderCart").length > 0 &&
        $("input#CartTermsHeaderCart")[0].checked
      ) {
        // continue to checkout
      } else {
        alert(window.cartStrings.cartTermsConfirmation);
        e.preventDefault();
        return false;
      }
    }
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: window.routes.cart_url,
      data: $(this)
        .parents('form[action="' + window.routes.cart_url + '"]')
        .serialize(),
      dataType: "json",
      success: function (cart) {
        window.location.href = "/checkout";
      },
      error: addToCartFail(),
    });
  });
});

class VariantProductcardSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantProductcardChange);
  }
  onVariantProductcardChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMediaPrice();
    this.closest(".card-wrapper")
      .querySelector('input[name="id"]')
      .setAttribute("value", this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateMediaPrice() {
    this.closest(".card-wrapper").querySelector(
      ".price__regular .price-item--regular"
    ).innerHTML = `From ${Shopify.formatMoney(this.currentVariant.price)}`;
    if (this.currentVariant.featured_image != null) {
      this.closest(".card-wrapper")
        .querySelector(".primery_card_image")
        .setAttribute("src", this.currentVariant.featured_image.src);
    }
  }
}
class VariantProductcard extends VariantProductcardSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-productcard", VariantProductcard);

let accordionBtn = document.querySelector(".accordion-btn");
let accordionContent = document.querySelector(".accordion-content");
let accordionTextarea = accordionContent.querySelector("textarea");

accordionBtn.addEventListener("click", function () {
  accordionBtn.classList.toggle("isOpen");
  toggleAccordionContent();
});

accordionBtn.addEventListener("keyup", function (event) {
  if (event.code == "Escape") {
    accordionBtn.classList.remove("isOpen");
    hideAccordionContent();
    event.preventDefault();
  }
});

accordionContent.addEventListener("keyup", function (event) {
  if (event.code == "Escape") {
    accordionBtn.classList.remove("isOpen");
    hideAccordionContent();
    event.preventDefault();
  }
});

function hideAccordionContent() {
  accordionContent.style.maxHeight = null;
  accordionTextarea.tabIndex = -1;
  accordionBtn.focus();
}

function showAccordionContent() {
  accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
  accordionTextarea.tabIndex = 0;
  accordionTextarea.focus();
}

function toggleAccordionContent() {
  if (accordionContent.style.maxHeight) {
    hideAccordionContent();
  } else {
    showAccordionContent();
  }
}
if (document.getElementById('complementary_slider')) {
  var elem = document.getElementById('complementary_slider');
  var flkty = new Flickity( elem, {
    // options
    cellAlign: 'center',
    contain: true
  });
}

